

























import Vue from 'vue'
import analytics from '~/mixins/analytics'
import Dashboard from '~/components/analytics/PurchaseAnalysis/Dashboard.vue'

export default Vue.extend({
  name: 'PurchaseAnalysisPage',
  components: {
    Dashboard,
  },
  mixins: [analytics],
  middleware: 'account_check',
  head() {
    return {
      title: `Purchase Analysis - ${this.currentProfileName} | ${this.currentProfile?.country}`,
    }
  },
})
